import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import{AddNewPolicyMdl} from '../../Models/AddNewPolicy';
@Component({
  selector: 'AddNewPolicy',
  templateUrl: './AddNewPolicy.html',
  styleUrls: ['./AddNewPolicy.css']
})
export class AddNewPolicy {
public AddNewPolicyObj:AddNewPolicyMdl=new AddNewPolicyMdl();
constructor(private router: Router){
  this.AddNewPolicyObj.VehicleDefionitionType="2";
  this.AddNewPolicyObj.ProductType="0000";
}

checked(Event:any) {
  if (Event.target.checked) {
      this.AddNewPolicyObj.Transfer = true;
  }
  else {
      this.AddNewPolicyObj.Transfer = false;
  }
}

Proceed(){
  this.router.navigate(['./PolicyDashboard/InsuredInfo']);
}

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/AddNewPolicy/AddNewPolicy.ts